import { create } from "zustand"

export const useCreditsStore = create(set => ({
  credits: [],

  setCredits: newCredits =>
    set(state => ({
      credits: [...newCredits]
    })),

  resetCredits: () => set({ credits: [] })
}))
